module.exports = __webpack_public_path__ + "static/hover-base-bf6d028e4c327f2d5eacbe7414cf4789.png";